'use client';

import { PrefetchLink } from '@shared-components/PrefetchLink/PrefetchLink';

import { MediaImage } from '../MediaImage/MediaImage';
import type { CarTypeItemProperties } from './CarType.entity';

import styles from './CarType.module.css';

interface CarProps extends CarTypeItemProperties {
  priority: boolean;
}

const Car = (props: CarProps) => {
  const { label, description, image, link, priority } = props;
  const firstImg = image?.[0];

  return (
    <PrefetchLink href={link || '/'} prefetch={priority}>
      <div className={styles.carType}>
        <div className={styles.image}>
          {firstImg && (
            <MediaImage
              image={firstImg}
              alt={label ?? firstImg.name}
              objectFit="contain"
              sizes="25vw"
              loading="lazy"
            />
          )}
        </div>
        <div className={styles.carTypeTitle}>{label}</div>
        <div>{description}</div>
      </div>
    </PrefetchLink>
  );
};

export default Car;
